import { moveToFulfilled, moveToPending, moveToRejected, update } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  GroupSidebarAboutLoadAction,
  GroupSidebarAboutLoadFulfilledAction,
} from '../../domains/groupSidebarAboutLoad/actions.types';
import { GroupEditFulfilledAction } from '../../domains/groups/actions.types';
import { Group } from '../types';

import { GroupSidebarAbout, GroupSidebarsAbout } from './types';

export type GroupSidebarAboutAction = GroupSidebarAboutLoadAction | GroupEditFulfilledAction;

const initialState: GroupSidebarsAbout = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

type NormalizedFulfilledEntities = (
  action: GroupSidebarAboutLoadFulfilledAction['payload']
) => Record<string, GroupSidebarAbout>;
const normalizedFulfilledEntities: NormalizedFulfilledEntities = ({ groupId, description }) => ({
  [groupId]: {
    id: groupId,
    description: description ?? undefined,
  },
});

const updatedAboutDescription = ({ id, description }: Group) => ({ id, description });

const reducer: Reducer<GroupSidebarsAbout, GroupSidebarAboutAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'GROUP_SIDEBAR_ABOUT.LOAD_PENDING':
      return moveToPending(state, [action.payload.groupId]);
    case 'GROUP_SIDEBAR_ABOUT.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.groupId], action.payload.error);
    case 'GROUP_SIDEBAR_ABOUT.LOAD_FULFILLED':
      return moveToFulfilled(state, normalizedFulfilledEntities(action.payload));
    case 'GROUP.EDIT_FULFILLED':
      return update(
        state,
        action.payload.groupId,
        updatedAboutDescription(action.payload.entities.groups[action.payload.groupId])
      );
    default:
      return state;
  }
};

export default reducer;
